import { ToggleGroup, ToggleItem } from '@/components/ToggleGroup'
import { RequestedProviderSelection } from '@/features/jobs/drafting/DraftPersister'
import { observer } from 'mobx-react-lite'
import { type PreviousProviderSelectionViewModel } from '@/features/jobs/drafting/PreviousProviderSelectionViewModel'

export interface PreviousProviderSelectorContainerProps {
  vm: PreviousProviderSelectionViewModel
}

export const PreviousProviderSelectorContainer = observer(
  function PreviousProviderSelectorContainer({
    vm,
  }: PreviousProviderSelectorContainerProps) {
    return (
      <ToggleGroup
        stretch
        focus$={vm.step.becomeActive$}
        onFocus={vm.step.onBecameActive}
      >
        <ToggleItem
          toggled={vm.selected === RequestedProviderSelection.firstAvailable}
          onChange={vm.selectFirstAvailable}
          isDisabled={vm.disabled}
          testId="draft-editor-provider-selection-first-available"
        >
          First Available
        </ToggleItem>
        {vm.availableProviders.map((provider) => (
          <ToggleItem
            title={provider.displayName}
            key={provider.user.publicId}
            toggled={vm.selected === provider}
            onChange={() => vm.select(provider)}
            isDisabled={vm.disabled}
            testId={`draft-editor-provider-selection-provider-${provider.displayName}`}
          >
            {provider.displayName}
          </ToggleItem>
        ))}
      </ToggleGroup>
    )
  },
)
